document.addEventListener('DOMContentLoaded', function () {
    const testimonialsSection = document.querySelector('.testimonials-section');

    if (testimonialsSection) {
      // Initialize Glide with responsive configuration
      let glideInstance = null;
      
      const initGlide = () => {
        const isMobile = window.innerWidth < 1081;
        
        // Destroy existing instance if it exists
        if (glideInstance) {
          glideInstance.destroy();
        }

        // Configuration for different viewports
        const config = isMobile ? {
          type: 'slider',
          perView: 1,
          bound: true,
          startAt: 0,
          rewind: false
        } : {
          type: 'carousel',
          perView: 1,
          focusAt: '0',
          startAt: 0,
          bound: true,
          rewind: false,
          gap: 40,
          peek: {
            before: 0,
            after: window.innerWidth - 1248
          }
        };

        glideInstance = new Glide('.testimonials-section.glide', config).mount();
      };

      // Initial initialization
      initGlide();

      // Add resize handler with debounce
      let resizeTimer;
      window.addEventListener('resize', () => {
        initGlide();
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(initGlide, 250);
      });
    }
  });